<h2 mat-dialog-title translate>Delete Report Folder</h2>

<mat-dialog-content>
    <div>This will delete the folder <b>{{reportFolderName}}.</b>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="okDeleteFolderButton" image="save.png" label="OK" translate (clickEvent)="okClick()"></tyl-button>
        <tyl-button id="cancelDeleteFolderButton" image="cancel.png" label="Cancel" translate (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>